import React from "react";
import { Header } from "../../../components/Header";
import "./styles.less";
import { Footer } from "../../../components/FooterV2";
import { HomeTryOn } from "../../../blocks/home-try-on";

import { ReplaceAuth0 } from "./ReplaceAuth0";
import { SolutionTable } from "./SolutionTable";
import Helmet from "react-helmet";
import { SolutionProduct } from "../../../components/SolutionProduct";
import { SolutionBanner } from "../../../blocks/solution-banner-new";
import { useTranslation } from "react-i18next";
import { KeycloakMarquee } from "./ManufacturingMarquee";

export const KeycloakPage = () => {
  const { t } = useTranslation();
  const banner = {
    title: t("solution.keycloak.banner.title"),
    subtitle: t("solution.keycloak.banner.description"),
    background: "solution-keycloak-banner.png",
    link: "https://www.authing.cn/authingform?fromTag=keycloak",
    tryon: true,
  };
  return (
    <div className="auth0-page">
      <Helmet>
        <title>替代keycloak的单点登录与权限管理解决方案-Authing身份云</title>
      </Helmet>
      <Header mode="dark" hasNotice />
      <SolutionBanner {...banner} />
      <ReplaceAuth0 />
      <KeycloakMarquee />
      <SolutionTable />
      <SolutionProduct />
      <HomeTryOn hasBg />
      <Footer />
    </div>
  );
};
